var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"avatar float-right mr-0"},[_c('img',{attrs:{"left":"","src":_vm.icon ? _vm.icon : _vm.$icons.TopNav.GuestAvatar,"alt":"Avatar"},on:{"click":_vm.navigateToUser}}),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }